
import './App.css';
import Form from './component/Form';


function App() {
  return (
    <div className="App ">
    
     <Form/>
     <p className='p-text text-center text-light  '>
               Created By: <span style={{color:"red"}}>Sachitha Madhuranga</span></p>

          </div>
  );
}

export default App;
